module.exports = async () => {
    return await import('@line/liff');
};
